import { render, staticRenderFns } from "./MultipleSchoolSet.vue?vue&type=template&id=8058c1e2&scoped=true"
import script from "./MultipleSchoolSet.vue?vue&type=script&lang=js"
export * from "./MultipleSchoolSet.vue?vue&type=script&lang=js"
import style0 from "./MultipleSchoolSet.vue?vue&type=style&index=0&id=8058c1e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8058c1e2",
  null
  
)

export default component.exports